import { render, staticRenderFns } from "./OfficePunish.vue?vue&type=template&id=0493f4da"
import script from "./OfficePunish.vue?vue&type=script&lang=js"
export * from "./OfficePunish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports